import React from 'react';
import PropTypes from 'prop-types';
import Form from '../../../components/user/article/articleForm';
import Layout from '../../../components/layouts/verticalLayout';
import { useParams } from 'react-router-dom';

const ArticleFormPage = () => {
  let { uuid } = useParams();
  return <Layout body={<Form uuid={uuid} />} />;
};

ArticleFormPage.propTypes = {};

export default ArticleFormPage;
